import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default {
  path: '/mp/',
  name: 'mp',
  meta: {
    auth: true
  },
  redirect: {
    name: 'mp-index'
  },
  component: layoutHeaderAside,
  children: (pre => [{
    path: 'account',
    name: `${pre}account`,
    component: _import('mp/account'),
    meta: {
      title: '账号矩阵'
    }
  }, {
    path: 'news',
    name: `${pre}news`,
    component: _import('mp/news'),
    meta: {
      title: '文章管理'
    }
  },
  {
    path: 'user',
    name: `${pre}user`,
    component: _import('mp/user'),
    meta: {
      title: '用户管理'
    }
  },
  {
    path: 'order',
    name: `${pre}order`,
    component: _import('mp/order'),
    meta: {
      title: '订单管理'
    }
  }

  ])('mp-')
}
